export const EVENT_NAME_MAPPING = {
  loaded: 'Visualizer Loaded',
  roomLoaded: 'Room Loaded',
  viewProduct: 'Product Viewed',
  productSelected: 'Product Clicked',
  requestSample: 'Requested Sample',
  requestPhone: 'Requested Phone',
  requestEmail: 'Requested Email',
  emailContact: 'Requested Email',
  'Visualized Product': 'Product Visualized',
  'Clicked Flooring Product': 'Product Clicked',
  'Clicked Add Favorite Button': 'Product Added',
  'Clicked Remove Favorite Button': 'Product Removed',
  'Clicked Favorites Button': 'Cart Viewed',
  'Apply Filters': 'Product List Filtered',
  'Clicked Info Button': 'Product Viewed',
  'Session End': 'Session Ended',
  'User Session Start': 'Session Started',
};

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    vizLoader: any;
  }
}

export interface KioskEvent {
  eventResult: string;
  eventAction: string;
  eventName: string;
  eventFeature: string;
  eventData: VizEventData;
}
export interface VizEventData {
  occurredAt?: string;
  brandExtId: string;
  brandId: number;
  brandName: string;
  collectionExtId: string;
  collectionId: number;
  collectionName: string;
  currentPage: string;
  dealerExtId: string;
  extId: string; // The external ID of the product
  id: number; // The internal ID of the product
  manufacturer: string;
  manufacturerExtId: string;
  manufacturerId: string;
  name: string;
  sku: string;
  templateId: number;
  templateName: string;
  uploadPhoto: boolean;
  filteredBrands?: string[];
  filteredTypes?: string[];
  filteredColors?: string[];
  userSession?: string;
  [k: string]: string | number | boolean | undefined | null | string[];
}
